import React, { useState, useEffect } from 'react';
import { Button, message, Empty } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import AutoReviewStatsDisplay from '../../components/AutoReviewStatsDisplay';

/**
 * 机审结果统计预览页面
 * 用于在新窗口中展示指标统计脚本的输出结果
 */
function AutoReviewPreviewPage() {
  const [statsData, setStatsData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 从 sessionStorage 中读取数据
    try {
      const dataStr = sessionStorage.getItem('metricOutputPreviewData');
      if (dataStr) {
        const parsedData = JSON.parse(dataStr);
        setStatsData(parsedData);
      } else {
        message.warning('没有找到预览数据');
      }
    } catch (error) {
      console.error('解析预览数据失败:', error);
      message.error('数据解析失败');
    } finally {
      setLoading(false);
    }

    // 清理 sessionStorage
    return () => {
      sessionStorage.removeItem('metricOutputPreviewData');
    };
  }, []);

  const handleClose = () => {
    window.close();
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        加载中...
      </div>
    );
  }

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#f5f5f5',
      padding: '24px'
    }}>
      {/* 顶部工具栏 */}
      <div style={{ 
        background: '#fff', 
        padding: '16px 24px', 
        marginBottom: '24px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Button 
            icon={<ArrowLeftOutlined />} 
            onClick={handleClose}
          >
            关闭页面
          </Button>
          <h1 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: '#1a1a1a' }}>
            机审结果统计页预览
          </h1>
          <span style={{ 
            background: '#e6f7ff', 
            color: '#1890ff', 
            padding: '4px 12px', 
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: 500
          }}>
            调试输出
          </span>
        </div>
      </div>

      {/* 统计内容 */}
      <div style={{ 
        background: '#fff', 
        padding: '32px', 
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}>
        {statsData && Object.keys(statsData).length > 0 ? (
          <AutoReviewStatsDisplay 
            data={statsData} 
          />
        ) : (
          <Empty 
            description="暂无统计数据" 
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        )}
      </div>
    </div>
  );
}

export default AutoReviewPreviewPage;
